<template>
  <v-card>
    <v-card-title>
      <v-tabs grow v-model="data.type">
        <v-tab>订单</v-tab>
        <v-tab>销量</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <line-chart :data="storeSummaries"/>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <store-selector v-model="data.stores"/>
      <v-spacer/>
      <date-range-picker v-model="data.dates"/>
      <v-spacer/>
<!--      <v-switch v-model="data.dayMode"/> {{ data.dayMode ? "按天" : "按时" }}-->
      <v-spacer/>
    </v-card-actions>
  </v-card>
</template>

<script>
import DateRangePicker from "@/components/DateRangePicker";
import StoreSelector from "@/components/StoreSelector";
import dayjs from "dayjs";
import LineChart from "@/components/LineChart";

export default {
  name: "CardStoreSummary",
  components: {
    LineChart,
    StoreSelector,
    DateRangePicker
  },
  computed: {
    startDate() {
      if (this.data.dates) {
        if (this.data.dates.length > 1) {
          let date1 = this.data.dates[0];
          let date2 = this.data.dates[1];

          if (dayjs(date1).isBefore(date2)) {
            return date1;
          } else {
            return date2;
          }
        } else if (this.data.dates.length > 0) {
          return this.data.dates[0];
        }
      }
      return dayjs().format("YYYY-MM-DD");
    },
    endDate() {
      if (this.data.dates) {
        if (this.data.dates.length > 1) {
          let date1 = this.data.dates[0];
          let date2 = this.data.dates[1];

          if (!dayjs(date1).isBefore(date2)) {
            return date1;
          } else {
            return date2;
          }
        }
      }
      return null;
    },

  },
  data() {
    return {
      menu: false,
      data: {
        type: 0,
        dates: [],
        stores: [],
      },
      storeSummaries: {},
    }
  },
  methods: {
    getData() {
      if (!this.data.stores || this.data.stores.length === 0) {
        this.storeSummaries = {}
        return;
      }

      let params = {
        market: localStorage.getItem("selectedTimer"),
        type: this.data.type,
        stores: this.data.stores,
        startDate: this.startDate
      };

      if (this.endDate) {
        params.endDate = this.endDate;
      }

      this.$axios.get("/store/summary", {
        params: params,
        paramsSerializer: params => {
          return this.$qs.stringify(params, {indices: false})
        }
      }).then(response => {
        this.storeSummaries = response.data;
      });
    }
  },
  watch: {
    "data": {
      deep: true,
      handler() {
        this.getData();
      }
    }
  }
}
</script>

<style scoped>
.chart {
  height: 300px;
}
</style>